import { render } from "./Revendeur.vue?vue&type=template&id=5bc47b52&scoped=true"
import script from "./Revendeur.vue?vue&type=script&lang=js"
export * from "./Revendeur.vue?vue&type=script&lang=js"

import "./Revendeur.vue?vue&type=style&index=0&id=5bc47b52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc47b52"]])

export default __exports__